export { PrivacyPolicyPage as default } from "@nvb/ui";
